var _image;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "email_2_",
    "data-name": "email (2)",
    width: 18,
    height: 18,
    opacity: 0.84,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYEAQAAAAa7ikwAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAAAGAAAABgAPBrQs8AAAAHdElNRQflBwUMECRweANXAAABsElEQVRIx9WVMU7rQBCG/10MgZYO7sAJ6BFSCgqISRMiQcMBOAZnCEGhCYgCiY7cAq6AOQFJwMl+FEMUzHMSB/L09Kbzev1//8x4Z6X/PZwkwdqatLGxWOmXF+d6PcHhIXS7LDy6XYhjB0li7p+exNmZNBz+zrn3cufn0taWlCQCIDw8wGAArRYsLf1UGryHZhMGA0KnA2AATk8hjiFNod0mRNHvxI+OTPMLQJIIlQqkKeH6eh7Id3FbywEY5OAA3t/h5oawvPwT8akAe7m/XwQySXwmwDaUy9DvE25v8yDTxAsBMhDu7wmlUlHxrwA/vcDr61IUSeWyXLtNWFkB76VGQ6rXR1IzmjShRKFWs7NxcQF7e/D2Bnd3cHlp6/X6OItaba4S2fhIUxP33tZ2d6HXy/6Ko1INhzDKaAYg69z77Efb24SdncnNHmeSf9CoVr87LxJ5mYwA0XhTtSq1WtLVlXRy4lwIRQHOhQDHx/bUaGTabsOu07GyNJvzOJ+cyXjYOXh+ljY3pcdHG9fFnefHH+M6jv/OhfP6SqhUPq/M1VXLYpGRJM71+4vV/BfxAS9c1WtI3VPhAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDIxLTA3LTA1VDEyOjE2OjM2KzAwOjAw90+dDAAAACV0RVh0ZGF0ZTptb2RpZnkAMjAyMS0wNy0wNVQxMjoxNjozNiswMDowMIYSJbAAAAAASUVORK5CYII="
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.1e76ae16cf6d60803dbebb979ebdd851.svg";
export { ForwardRef as ReactComponent };